import { ref, onMounted, onUnmounted } from 'vue';

const POLL_MS = 5 * 60 * 1000;

async function fetchBuildHash(): Promise<string> {
  const res = await fetch('/', { cache: 'no-store' });
  const html = await res.text();
  const m = html.match(/src="[^"]*\/assets\/index-([^"]+)\.js"/);
  return m ? m[1] : '';
}

export function useVersionCheck() {
  const updateAvailable = ref(false);
  let initialHash = '';
  let timer: ReturnType<typeof setInterval> | null = null;

  async function check() {
    try {
      const hash = await fetchBuildHash();
      if (initialHash && hash && hash !== initialHash) {
        updateAvailable.value = true;
        if (timer) clearInterval(timer);
      }
    } catch { }
  }

  onMounted(async () => {
    initialHash = await fetchBuildHash();
    timer = setInterval(check, POLL_MS);
  });

  onUnmounted(() => {
    if (timer) clearInterval(timer);
  });

  return { updateAvailable };
}
